import script from "./FeatureCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./FeatureCard.vue?vue&type=script&lang=ts&setup=true"

import "./FeatureCard.vue?vue&type=style&index=0&id=11e1160b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e1160b"]])

export default __exports__